import { render } from "./ViewNewYachts.vue?vue&type=template&id=3b66fa39"
import script from "./ViewNewYachts.vue?vue&type=script&lang=js"
export * from "./ViewNewYachts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__